(() => {
  const faccoI18n = window.FaccoI18n || {};
  const faccoText = (key, fallback, vars = {}) => {
    let value = String(faccoI18n[key] || fallback || '');
    Object.entries(vars).forEach(([name, replacement]) => { value = value.replaceAll(`{{ ${name} }}`, String(replacement)); });
    return value;
  };
  const initHeader = (root = document) => {
    root.querySelectorAll('[data-fac-header]').forEach((headerWrap) => {
      if (headerWrap.dataset.facReady) return;
      headerWrap.dataset.facReady = 'true';

      const drawer = document.querySelector('[data-fac-drawer]');
      const overlay = document.querySelector('[data-fac-overlay]');
      const openers = headerWrap.querySelectorAll('[data-fac-menu-open]');
      const closers = document.querySelectorAll('[data-fac-menu-close]');
      const submenuToggles = Array.from(document.querySelectorAll('[data-fac-submenu-toggle]'));

      const updateHeaderState = () => {
        headerWrap.classList.toggle('is-scrolled', window.scrollY > 24);
      };
      updateHeaderState();
      window.addEventListener('scroll', updateHeaderState, { passive: true });

      const setMenu = (open) => {
        drawer?.classList.toggle('is-open', open);
        overlay?.classList.toggle('is-open', open);
        document.body.classList.toggle('fac-premium-menu-open', open);
        openers.forEach((button) => button.setAttribute('aria-expanded', String(open)));
      };

      openers.forEach((button) => {
        button.addEventListener('click', () => setMenu(true));
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          button.addEventListener('mouseenter', () => setMenu(true));
        }
      });

      if (drawer && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        drawer.addEventListener('mouseleave', () => setMenu(false));
      }

      closers.forEach((button) => button.addEventListener('click', () => setMenu(false)));
      overlay?.addEventListener('click', () => setMenu(false));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setMenu(false);
      });

      submenuToggles.forEach((toggle) => {
        const targetId = toggle.getAttribute('aria-controls');
        const submenu = targetId ? document.getElementById(targetId) : toggle.parentElement?.querySelector('[data-fac-submenu]');
        toggle.addEventListener('click', () => {
          const next = toggle.getAttribute('aria-expanded') !== 'true';
          submenuToggles.forEach((other) => {
            if (other === toggle) return;
            other.setAttribute('aria-expanded', 'false');
            const otherId = other.getAttribute('aria-controls');
            const otherSubmenu = otherId ? document.getElementById(otherId) : other.parentElement?.querySelector('[data-fac-submenu]');
            otherSubmenu?.classList.remove('is-open');
          });
          toggle.setAttribute('aria-expanded', String(next));
          submenu?.classList.toggle('is-open', next);
        });
      });
    });
  };

  const initProductCarousels = (root = document) => {
    root.querySelectorAll('[data-fac-products-section]').forEach((section) => {
      if (section.dataset.facCarouselReady) return;
      section.dataset.facCarouselReady = 'true';

      const viewport = section.querySelector('[data-fac-products-viewport]');
      const track = section.querySelector('[data-fac-products-track]');
      const cards = Array.from(track?.querySelectorAll('.fac-product-card') || []);
      const prev = section.querySelector('[data-fac-products-prev]');
      const next = section.querySelector('[data-fac-products-next]');
      const counter = section.querySelector('[data-fac-products-counter]');
      if (!viewport || !track || cards.length === 0) return;

      let page = 0;
      let pages = [];

      const perPage = () => window.matchMedia('(min-width: 990px)').matches ? 4 : 2;

      const buildPages = () => {
        const step = perPage();
        pages = [];
        const viewportLeft = viewport.getBoundingClientRect().left;
        for (let index = 0; index < cards.length; index += step) {
          const cardLeft = cards[index].getBoundingClientRect().left;
          pages.push(Math.max(0, Math.round(cardLeft - viewportLeft + viewport.scrollLeft)));
        }
        page = Math.min(page, Math.max(0, pages.length - 1));
      };

      const updateControls = () => {
        const total = Math.max(1, pages.length);
        if (counter) counter.textContent = `${page + 1} / ${total}`;
        if (prev) prev.disabled = page <= 0;
        if (next) next.disabled = page >= total - 1;
      };

      const goToPage = (target, behavior = 'smooth') => {
        page = Math.max(0, Math.min(target, pages.length - 1));
        viewport.scrollTo({ left: pages[page] || 0, behavior });
        updateControls();
      };

      prev?.addEventListener('click', () => goToPage(page - 1));
      next?.addEventListener('click', () => goToPage(page + 1));

      let resizeTimer;
      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          buildPages();
          goToPage(page, 'auto');
        }, 120);
      }, { passive: true });

      viewport.scrollLeft = 0;
      buildPages();
      goToPage(0, 'auto');
    });
  };

  const normalizeCarat = (value = '') => value.toLowerCase().replace(/\s+/g, '').replace('kt', '');

  const getCurrentVariant = () => {
    const node = document.getElementById('FaccoCurrentProductJson');
    if (!node) return null;
    let product;
    try { product = JSON.parse(node.textContent); } catch (_) { return null; }
    const picker = document.querySelector('variant-picker');
    if (!picker) return product.selected_or_first_available_variant || product.variants?.[0] || null;
    const selected = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => fieldset.querySelector('input:checked')?.value || '');
    const variant = product.variants?.find((item) => item.options?.every((option, index) => option === selected[index]));
    return variant || product.selected_or_first_available_variant || product.variants?.[0] || null;
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'it-IT';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  };

  const initProductVariantEnhancements = (root = document) => {
    const picker = root.querySelector?.('variant-picker') || document.querySelector('variant-picker');
    if (!picker || picker.dataset.facVariantReady) return;
    picker.dataset.facVariantReady = 'true';

    const sync = () => {
      picker.querySelectorAll('.variant-option__button-label').forEach((label) => {
        label.classList.toggle('is-selected', Boolean(label.querySelector('input:checked')));
      });
      const variant = getCurrentVariant();
      if (!variant) return;
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => { input.value = variant.id; });
      document.querySelectorAll('product-price [ref="priceContainer"] .price').forEach((price) => { price.textContent = formatMoney(variant.price); });
      document.dispatchEvent(new CustomEvent('facco:variant-change', { detail: { variant } }));
    };
    picker.addEventListener('change', () => { sync(); window.setTimeout(sync, 80); window.setTimeout(sync, 450); });
    new MutationObserver(sync).observe(picker, { childList:true, subtree:true, attributes:true, attributeFilter:['checked'] });
    sync();
  };

  const initPairings = (root = document) => {
    root.querySelectorAll?.('[data-fac-pairings]').forEach((section) => {
      if (section.dataset.facPairingsReady) return;
      section.dataset.facPairingsReady = 'true';

      const mode = section.dataset.mode;
      const cards = Array.from(section.querySelectorAll('[data-fac-addon]'));
      const summary = section.querySelector('[data-fac-pairing-summary]');
      const count = section.querySelector('[data-fac-pairing-count]');
      const addButton = section.querySelector('[data-fac-add-composition]');

      const productData = (card) => {
        try {
          return JSON.parse(card.querySelector('[data-fac-addon-json]')?.textContent || '{}');
        } catch (_) {
          return {};
        }
      };

      const currentCarat = () => {
        const variant = getCurrentVariant();
        if (!variant) return '';
        const caratOption = variant.options?.find((value) => /(?:9|18)\s*kt/i.test(String(value)));
        return caratOption ? normalizeCarat(caratOption) : '';
      };

      const compatibleVariants = (card) => {
        const data = productData(card);
        const carat = currentCarat();
        const available = (data.variants || []).filter((variant) => variant.available !== false);
        if (!carat) return available;
        return available.filter((variant) => variant.options?.some((option) => normalizeCarat(option) === carat));
      };

      const variantLabel = (variant) => {
        const values = (variant.options || []).filter((value) => value && value !== 'Default Title');
        return values.length ? values.join(' · ') : faccoText('uniqueVariant', 'Variante unica');
      };

      const renderVariantSelect = (card, variants) => {
        const select = card.querySelector('[data-fac-addon-variant]');
        if (!select) return variants[0] || null;

        const previousId = String(select.value || card.dataset.variantId || '');
        select.innerHTML = '';

        variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = `${variantLabel(variant)} — ${formatMoney(variant.price)}`;
          select.appendChild(option);
        });

        if (variants.some((variant) => String(variant.id) === previousId)) {
          select.value = previousId;
        }

        select.disabled = variants.length === 0;
        const selected = variants.find((variant) => String(variant.id) === String(select.value)) || variants[0] || null;
        if (selected) select.value = String(selected.id);
        return selected;
      };

      const updateCard = (card) => {
        const variants = compatibleVariants(card);
        const select = card.querySelector('[data-fac-addon-variant]');
        let variant = null;

        if (select) {
          variant = renderVariantSelect(card, variants);
        } else {
          const previousId = String(card.dataset.variantId || '');
          variant = variants.find((item) => String(item.id) === previousId) || variants[0] || null;
        }

        card.dataset.variantId = variant?.id || '';
        card.classList.toggle('is-incompatible', !variant);

        const price = card.querySelector('[data-fac-addon-price]');
        if (price && variant) price.textContent = formatMoney(variant.price);

        const toggle = card.querySelector('[data-fac-addon-toggle]');
        if (toggle) toggle.disabled = !variant;

        if (!variant && card.classList.contains('is-selected')) {
          card.classList.remove('is-selected');
          toggle?.setAttribute('aria-pressed', 'false');
          if (toggle) toggle.textContent = faccoText('add', 'AGGIUNGI');
        }

        return variant;
      };

      const selectedCards = () => cards.filter((card) => card.classList.contains('is-selected') && card.dataset.variantId);

      const updateDrawerStatuses = () => {
        section.querySelectorAll('[data-fac-drawer]').forEach((drawer) => {
          const selected = Array.from(drawer.querySelectorAll('[data-fac-addon].is-selected'));
          const status = section.querySelector(`[data-fac-drawer-status="${drawer.id}"]`);
          if (!status) return;
          if (selected.length === 0) {
            status.textContent = '';
            status.closest('[data-fac-drawer-open]')?.classList.remove('has-selection');
            return;
          }
          const firstTitle = productData(selected[0]).title || '';
          status.textContent = selected.length === 1 ? firstTitle : faccoText('selectedMany', '{{ count }} selezionati', { count: selected.length });
          status.closest('[data-fac-drawer-open]')?.classList.add('has-selection');
        });
      };

      const update = () => {
        cards.forEach(updateCard);
        const selected = selectedCards();
        if (summary) summary.hidden = selected.length === 0;
        if (count) {
          if (mode === 'charm') {
            const title = selected[0] ? productData(selected[0]).title : '';
            count.textContent = title ? faccoText('baseSelected', 'Base selezionata: {{ title }}', { title }) : '';
          } else {
            count.textContent = selected.length === 1 ? faccoText('oneCharmSelected', '1 charm selezionato') : faccoText('manyCharmsSelected', '{{ count }} charm selezionati', { count: selected.length });
          }
        }
        updateDrawerStatuses();
      };

      cards.forEach((card) => {
        const select = card.querySelector('[data-fac-addon-variant]');
        select?.addEventListener('change', () => {
          const data = productData(card);
          const variant = (data.variants || []).find((item) => String(item.id) === String(select.value));
          card.dataset.variantId = variant?.id || '';
          const price = card.querySelector('[data-fac-addon-price]');
          if (price && variant) price.textContent = formatMoney(variant.price);
          updateDrawerStatuses();
        });

        card.querySelector('[data-fac-addon-toggle]')?.addEventListener('click', () => {
          if (card.classList.contains('is-incompatible')) return;

          if (mode === 'charm' && !card.classList.contains('is-selected')) {
            cards.forEach((other) => {
              if (other === card) return;
              other.classList.remove('is-selected');
              const otherToggle = other.querySelector('[data-fac-addon-toggle]');
              otherToggle?.setAttribute('aria-pressed', 'false');
              if (otherToggle) otherToggle.textContent = faccoText('add', 'AGGIUNGI');
            });
          }

          card.classList.toggle('is-selected');
          const selected = card.classList.contains('is-selected');
          const toggle = card.querySelector('[data-fac-addon-toggle]');
          toggle?.setAttribute('aria-pressed', String(selected));
          if (toggle) toggle.textContent = selected ? faccoText('remove', 'RIMUOVI') : faccoText('add', 'AGGIUNGI');
          update();
        });
      });

      const closeDrawer = (drawer) => {
        if (!drawer) return;
        drawer.setAttribute('aria-hidden', 'true');
        drawer.hidden = true;
        const trigger = section.querySelector(`[data-fac-drawer-open="${drawer.id}"]`);
        trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('fac-addon-drawer-open');
        trigger?.focus({ preventScroll: true });
      };

      const openDrawer = (drawer) => {
        if (!drawer) return;
        section.querySelectorAll('[data-fac-drawer]:not([hidden])').forEach((other) => {
          if (other !== drawer) closeDrawer(other);
        });
        drawer.hidden = false;
        drawer.setAttribute('aria-hidden', 'false');
        const trigger = section.querySelector(`[data-fac-drawer-open="${drawer.id}"]`);
        trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('fac-addon-drawer-open');
        window.requestAnimationFrame(() => drawer.querySelector('[data-fac-drawer-close]')?.focus({ preventScroll: true }));
      };

      section.querySelectorAll('[data-fac-drawer-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => openDrawer(section.querySelector(`#${CSS.escape(trigger.dataset.facDrawerOpen)}`)));
      });

      section.querySelectorAll('[data-fac-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => closeDrawer(button.closest('[data-fac-drawer]')));
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const drawer = section.querySelector('[data-fac-drawer]:not([hidden])');
        if (drawer) closeDrawer(drawer);
      });

      document.addEventListener('facco:variant-change', update);

      addButton?.addEventListener('click', async () => {
        const main = getCurrentVariant();
        const selected = selectedCards();
        if (!main || selected.length === 0) return;
        addButton.disabled = true;
        try {
          const items = [{ id: Number(main.id), quantity: 1 }, ...selected.map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }))];
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Cart error');
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (_) {
          addButton.disabled = false;
          addButton.textContent = faccoText('retry', 'Riprova');
        }
      });

      if (section.hasAttribute('data-fac-inline-pairings')) {
        const form = section.closest('.product-details')?.querySelector('product-form-component form[action*="/cart/add"]');
        if (form && !form.dataset.facCompositionReady) {
          form.dataset.facCompositionReady = 'true';
          form.addEventListener('submit', async (event) => {
            const selected = selectedCards();
            if (selected.length === 0) return;
            const main = getCurrentVariant();
            if (!main) return;

            event.preventDefault();
            event.stopImmediatePropagation();
            const submitButton = form.querySelector('[type="submit"]');
            if (submitButton) submitButton.disabled = true;

            try {
              const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
              const items = [
                { id: Number(main.id), quantity },
                ...selected.map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }))
              ];
              const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items })
              });
              if (!response.ok) throw new Error('Cart error');
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
            } catch (_) {
              if (submitButton) submitButton.disabled = false;
            }
          }, true);
        }
      }

      update();
    });
  };

  const initCollectionEditorial = (root = document) => {
    if (!document.body.classList.contains('template-collection')) return;
    const intro = document.querySelector('[data-fac-collection-intro]');
    const grid = document.querySelector('.product-grid');
    if (!intro || !grid || grid.dataset.facEditorialReady) return;

    const productItems = Array.from(grid.children).filter((item) => item.classList?.contains('product-grid__item'));
    if (productItems.length === 0) return;

    const insertTile = (templateNumber, afterProductNumber) => {
      const template = intro.querySelector(`[data-fac-editorial-template="${templateNumber}"]`);
      const target = productItems[afterProductNumber - 1];
      if (!template || !target || !template.content.firstElementChild) return;
      target.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
    };

    insertTile(1, 2);
    insertTile(2, 10);
    grid.dataset.facEditorialReady = 'true';
  };

  const initProductHeaderOffset = () => {
    if (!document.body.classList.contains('template-product')) return;
    const headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    const sync = () => {
      const height = Math.ceil(headerGroup.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--facco-product-header-height', `${height}px`);
    };

    if (!headerGroup.dataset.facProductOffsetReady) {
      headerGroup.dataset.facProductOffsetReady = 'true';
      window.addEventListener('resize', sync, { passive: true });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(sync);
        observer.observe(headerGroup);
        headerGroup._facProductHeaderObserver = observer;
      }
    }
    sync();
  };

  const initAll = (root = document) => {
    initHeader(root);
    initProductHeaderOffset();
    initCollectionEditorial(root);
    initProductCarousels(root);
    initProductVariantEnhancements(root);
    initPairings(root);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
